import StagingPage from "./StagingPage";

export default StagingPage;
